import {
  ParagraphExercise,
  ParagraphPhase,
  ParagraphVideo,
  ParagraphWebform,
  ParagraphOnboardingQuestion,
  ParagraphText,
  ParagraphBlockReference,
  ParagraphFaq,
  ParagraphFrontPageProgram,
  ParagraphFrontPagePrograms,
  ParagraphTextImage,
  ParagraphCta,
  ParagraphTextVideo,
} from '../implementations';

const mappers = {
  exercise: ParagraphExercise,
  phase: ParagraphPhase,
  video: ParagraphVideo,
  webform: ParagraphWebform,
  onboarding_question: ParagraphOnboardingQuestion,
  text: ParagraphText,
  block_reference: ParagraphBlockReference,
  faq: ParagraphFaq,
  frontpage_programs: ParagraphFrontPagePrograms,
  frontpage_program: ParagraphFrontPageProgram,
  text_image: ParagraphTextImage,
  cta: ParagraphCta,
  text_video: ParagraphTextVideo,
};

export default mappers;
